import moment from 'moment'
import { z } from 'zod'

export const PostponeTaskSchema = z
	.object({
		dueDate: z
			.string()
			.default(moment().add(1, 'days').startOf('day').toISOString())
			.transform(moment)
			.refine((value) => value.isValid() && moment().diff(value) < 0, {
				message: 'Date must be higher than today',
				path: ['dueDate'],
			}),
		taskFormState: z.string().optional(),
	})
	.strict()
